export const CreditColumns = [
  {
    accessor: "settlementMonth",
    Header: "دوره تسویه",
    header: "دوره تسویه",
    key: "settlementMonth",
  },
  {
    accessor: "hubName",
    Header: " هاب",
    header: " هاب",
    key: "hubName",
  },
  {
    accessor: "creditAmount",
    Header: "اعتبار اول دوره",
    header: "اعتبار اول دوره",
    key: "creditAmount",
  },
  {
    accessor: "tableusedCredit",
    Header: "اعتبار مصرف شده",
    header: "اعتبار مصرف شده",
    key: "tableusedCredit",
  },
  {
    accessor: "creditValidTo",
    Header: "تاریخ اتمام",
    header: "تاریخ اتمام",
    key: "creditValidTo",
  },
  {
    accessor: "receiveCredit",
    Header: "اعتبار دریافتی از ",
    header: "اعتبار دریافتی از ",
    key: "receiveCredit",
  },
  {
    accessor: "",
    Header: "موعد تسویه",
    header: "موعد تسویه",
    key: "",
  },
  {
    accessor: "settlementStatus",
    Header: "وضعیت پرداخت",
    header: "وضعیت پرداخت",
    key: "settlementStatus",
  },
  {
    accessor: "settledAmount",
    Header: "جمع پرداختی",
    header: "جمع پرداختی",
    key: "settledAmount",
  },
  {
    accessor: "settlementDate",
    Header: "تاریخ آخرین پرداخت",
    header: "تاریخ آخرین پرداخت",
    key: "settlementDate",
  },
  {
    accessor: "creditBalance",
    Header: " مانده اعتبار",
    header: " مانده اعتبار",
    key: "creditBalance",
  },
  {
    accessor: "percentage",
    Header: " درصد تسهیم ",
    header: " درصد تسهیم ",
    key: "percentage",
  },
  {
    accessor: "hubShareAmount",
    Header: " سهم نمایندگی",
    header: " سهم نمایندگی",
    key: "hubShareAmount",
  },

  {
    accessor: "insurance",
    Header: " سپرده بیمه",
    header: " سپرده بیمه",
    key: "insurance",
  },
  {
    accessor: "totalPayable",
    Header: " مبلغ قابل پرداخت",
    header: " مبلغ قابل پرداخت",
    key: "totalPayable",
  },
  // {
  //   accessor: "p",
  //   Header: " فیش بانکی",
  //   header: " فیش بانکی",
  // },
  {
    Header: "عملیات",
    accessor: "operation",
    key: "operation",
    header: "عملیات",
  },
]
